import { ArrowsDownUpIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { type HTMLAttributes } from "react";
import { useIntl } from "react-intl";

type SwapValuesButtonProps = HTMLAttributes<HTMLButtonElement>;

export function SwapValuesButton({
  className,
  onClick,
}: SwapValuesButtonProps) {
  const intl = useIntl();

  return (
    <button
      type="button"
      className={clsx(
        className,
        "rounded-full border border-core-rahal-800 bg-white p-1.5",
        "cursor-pointer transition-transform active:scale-90",
      )}
      onClick={onClick}
      aria-label={intl.formatMessage({
        defaultMessage: "Swap values",
        description:
          "Accessible label for the button that swaps origin and destination in the search form",
      })}
    >
      <ArrowsDownUpIcon className="size-5 text-core-rahal-800" />
    </button>
  );
}
